import type { Context } from 'react';
import { createContext } from 'react';

export interface TeamsClientOptions {
  readonly shouldHideLeftSidebar: boolean;
  readonly shouldHideHeaders: boolean;
}

export const defaultOptions: TeamsClientOptions = {
  shouldHideLeftSidebar: false,
  shouldHideHeaders: false,
};

export const TeamsClientContext: Context<TeamsClientOptions> = createContext(defaultOptions);
